import "./contact.css";
import { WrapperComponent, InputText, SectionTitle, WhatsappBtn, InputDropBox, SquareBtn } from "../../../_imports";
import BernardiImg from "../../../../assets/imgs/partners/bernardi.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { useEnterpriseContact } from "../../../../hooks/_imports";

function Contact() {
    const vacancyOptions = Array.from({ length: 50 }, (_, i) => i + 1);
    const { formData, handleChange, handleSubmit, loading, success, error } = useEnterpriseContact();

    return (
        <section className="contact-section">
            <WrapperComponent>
                <SectionTitle text="Ainda com dúvidas? Vamos conversar!" />
                <div className="contact-container">
                    <div className="contact-profile">
                        <div className="profile-header">
                            <div className="profile-image-container">
                                <img src={BernardiImg} alt="Lucas Bernardi" className="profile-image" />
                            </div>
                            <div className="profile-info">
                                <h3 className="profile-name">Lucas Bernardi</h3>
                                <p className="profile-role">Gerente Comercial</p>

                                <div className="profile-contact-item">
                                    <FontAwesomeIcon icon={faPhone} className="contact-icon" />
                                    <span>(46) 99123-2216</span>
                                </div>
                                <div className="profile-contact-item">
                                    <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                                    <span>comercial@tonalida.com.br</span>
                                </div>
                            </div>
                        </div>

                        <div className="profile-message-box">
                            <p>"Olá! Estou aqui para entender a necessidade da sua empresa e mostrar como a Tonalida pode transformar o seu recrutamento. Me chame no WhatsApp!"</p>
                        </div>
                        <WhatsappBtn number="46991232216" />
                    </div>

                    <div className="contact-form-container">
                        <h3 className="form-title">Ou receba uma proposta!</h3>
                        <form className="contact-form" onSubmit={handleSubmit}>
                            <InputText
                                label="Nome da Empresa"
                                id="companyName"
                                placeholder="Sua empresa"
                                type="text"
                                value={formData.companyName}
                                onChange={handleChange}
                                required
                                disabled={success}
                            />

                            <div className="form-row">
                                <InputText
                                    label="Telefone"
                                    id="phone"
                                    placeholder="(00) 00000-0000"
                                    type="tel"
                                    className="input-phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                    disabled={success}
                                />

                                <div className="input-vacancies">
                                    <InputDropBox
                                        label="Nº de Vagas"
                                        id="jobCount"
                                        options={[...vacancyOptions, "50+"]}
                                        placeholder="Selecione"
                                        value={formData.jobCount}
                                        onChange={handleChange}
                                        required
                                        disabled={success}
                                    />
                                </div>
                            </div>

                            {error && <p className="form-message error">{error}</p>}
                            {success && <p className="form-message success">Mensagem enviada com sucesso!</p>}

                            <SquareBtn
                                text={loading ? "Enviando..." : success ? "Enviado!" : "Enviar"}
                                type="submit"
                                className="submit-btn"
                                disabled={loading || success}
                            />
                        </form>
                    </div>
                </div>
            </WrapperComponent>
        </section>
    );
}

export default Contact;
